import { render } from "./catalogoDetailView.vue?vue&type=template&id=6323daca"
import script from "./catalogoDetailView.vue?vue&type=script&lang=js"
export * from "./catalogoDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__